module.exports = {
    DEPOSIT_THIRTEEN_MONTHS_PRODUCT_SUBTYPE_CODES: ['885', '884', '883', '882', '868']
};
